// extracted by mini-css-extract-plugin
export default {"carouselContainer":"bpASdesGVDFwNuR5SrqZ","carouselSlider":"U3Akfl_wz9cowxn_mBhv","paginationContainer":"AVc0wcrmYI4U23FcUuT7"};